//
//
//
//
//
//

import Viewer from '../../viewer/index';
import './viewer.scss';
export default {
	props: {
		images: {
			type: Array,
		},
		index: {
			type: Number,
		},
		trigger: {},
		options: {
			type: Object,
		},
	},
	name: 'Viewer',
	data() {
		return {};
	},
	computed: {},
	methods: {
		createViewer() {
			if (this.images.length == 0) {
				return;
			}
			this.$viewer && this.$viewer.destroy();
			this.$viewer = new Viewer(this.$el, {
				zIndex: 3000,
			});

			this.$viewer.view(this.index);
			// this.$viewer.show()
		},
	},

	watch: {
		images() {
			this.$nextTick(() => {
				this.createViewer();
			});
		},
		trigger: {
			handler: function() {
				this.$nextTick(() => {
					this.createViewer();
				});
			},
			deep: true,
		},
		options: {
			handler: function() {
				this.$nextTick(() => {
					this.createViewer();
				});
			},
			deep: true,
		},
	},

	mounted() {
		this.createViewer();
	},

	destroyed() {
		this.$viewer && this.$viewer.destroy();
	},
};
